import blueBgPng from '/img/rewards/blue-bg.png';
import blueBgWebp from '/img/rewards/blue-bg.webp';
import greenBgPng from '/img/rewards/green-bg.png';
import greenBgWebp from '/img/rewards/green-bg.webp';
import purpleBgPng from '/img/rewards/purple-bg.png';
import purpleBgWebp from '/img/rewards/purple-bg.webp';
import yellowBgPng from '/img/rewards/yellow-bg.png';
import yellowBgWebp from '/img/rewards/yellow-bg.webp';

export const rewardsBgImages = {
  blue: {
    png: blueBgPng,
    webp: blueBgWebp,
  },
  purple: {
    png: purpleBgPng,
    webp: purpleBgWebp,
  },
  yellow: {
    png: yellowBgPng,
    webp: yellowBgWebp,
  },
  green: {
    png: greenBgPng,
    webp: greenBgWebp,
  },
};
